import React from "react";
import { ComponentProps, ComponentWidth, PageLink } from "../../../types";
import DivWrapper from "../../containers/DivWrapper";
import { DesktopLinkBar } from "./DesktopLinkBar";
import { MobileLinkCarousel } from "./MobileLinkCarousel";

export interface LinkBarProps extends ComponentWidth {
  links: (PageLink & { active?: boolean })[];
}

interface LinkBarParentProps extends ComponentProps, LinkBarProps {}

export const LinkBar: React.FC<LinkBarParentProps> = ({
  id,
  anchor,
  hideOnMobile,
  ...props
}) => {
  return (
    <DivWrapper id={id} anchor={anchor} hideOnMobile={hideOnMobile}>
      <DesktopLinkBar {...props} />
      <MobileLinkCarousel {...props} />
    </DivWrapper>
  );
};
